module.exports = __webpack_public_path__ + "a53ec1d318f8d1c44613c374d0849c36.png";